import { useCallback, useMemo } from "react"
import { Userbot } from "../interfaces"
import { useAccountsQuery } from "../store"

export interface AccountsLookupResult {
  getAccount: (
    id: string | null | undefined,
  ) => Userbot.AccountFeedItem | undefined
  isLoading: boolean
}

export function useAccountsLookup(): AccountsLookupResult {
  const { data, isLoading } = useAccountsQuery({ limit: 500 })

  const map = useMemo(() => {
    const m = new Map<string, Userbot.AccountFeedItem>()
    data?.items?.forEach((a) => {
      if (a && a.id) {
        m.set(a.id, a)
      }
    })
    return m
  }, [data])

  const getAccount = useCallback(
    (id: string | null | undefined) => {
      if (!id) return undefined
      return map.get(id)
    },
    [map],
  )

  return { getAccount, isLoading }
}
